var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineSimcard2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.89 22.72c-2.73 0-4.64-1.91-4.64-4.64v-7.77c0-2.73 1.91-4.64 4.64-4.64h3.83c1.22 0 2.42.5 3.28 1.36l2.39 2.38c.87.87 1.36 2.06 1.36 3.28v5.39c0 2.73-1.91 4.64-4.64 4.64H5.89zM2.75 10.31v7.77c0 1.91 1.23 3.14 3.14 3.14h6.22c1.91 0 3.14-1.23 3.14-3.14v-5.39c0-.83-.34-1.63-.92-2.22l-2.39-2.38a3.16 3.16 0 0 0-2.22-.92H5.89c-1.91 0-3.14 1.23-3.14 3.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.28c-.41 0-.75-.34-.75-.75v-4.84c0-.83-.34-1.63-.92-2.22l-2.39-2.38a3.16 3.16 0 0 0-2.22-.92H8c-.41 0-.75-.34-.75-.75v-.56c0-2.73 1.91-4.64 4.64-4.64h3.83c1.22 0 2.42.5 3.28 1.36l2.39 2.39c.88.88 1.36 2.04 1.36 3.28v5.39c0 2.73-1.91 4.64-4.64 4.64H16zm2.11-1.5c1.91 0 3.14-1.23 3.14-3.14V8.25c0-.84-.33-1.63-.92-2.22l-2.39-2.39c-.58-.58-1.39-.92-2.22-.92h-3.83c-1.84 0-3.06 1.15-3.14 2.95h.97c1.22 0 2.42.5 3.28 1.36l2.39 2.38c.87.87 1.36 2.06 1.36 3.28v4.09h1.36z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSimcard2);
export default __webpack_public_path__ + "static/media/vuesax-outline-simcard-2.96a3ddeb7eea194c572afbc3cb89043c.svg";
export { ForwardRef as ReactComponent };